import * as React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import LinkListItem from './Item';

import MasonryGrid from '../MasonryGrid';
import Slider from '../Slider';

import './style.scss';

interface LinkListSubComponents {
  Item: typeof LinkListItem;
}

const LinkList: React.FC & LinkListSubComponents = (props) => {
  const { children } = props;

  return (
    <div className="LinkList">
      <div className="LinkList__sliderwrapper">
        <Slider>
          {children}
        </Slider>
      </div>
      <div className="LinkList__gridwrapper">
        <Container>
          {/* @ts-ignore */}
          <MasonryGrid items={children} />
        </Container>
      </div>
    </div>
  );
};

LinkList.Item = LinkListItem;

export default LinkList;
